/* eslint complexity: "off", max-depth: "off" */
import moment from 'moment'

export default data => {
  if (!Array.isArray(data)) {
    throw new Error('Invalid data format. Data must be an array.')
  }
  const discrepancies = []
  const categories = []
  const years = []
  for (const datum of data) {
    if (categories.indexOf(datum.category) < 0) {
      categories.push(datum.category)
    }
    if (years.indexOf(datum.year) < 0) {
      years.push(datum.year)
    }
  }
  years.sort()
  for (const category of categories) {
    for (let i = 0; i < years.length; i++) {
      const year = years[i]
      const filteredByYearAndCategory = data.filter(datum => datum.category === category && datum.year === year).sort((a, b) => b.createdAt - a.createdAt)
      const hasTranscripts = Boolean(filteredByYearAndCategory.find(datum => datum.source === 'tax_transcript')) // Check to see if year has any tax_transcripts
      if (filteredByYearAndCategory.length > 1 && hasTranscripts) {
        if (filteredByYearAndCategory[0].source !== 'tax_transcript') { // If there is data that came after the transcript, assume that it is an adjustment and do not create a discrepancy
          continue
        } else if (filteredByYearAndCategory.length > 1 && hasTranscripts) { // If there are transcripts and the prior data was not manual_transcripts, check to see if there is an difference between the two
          const diff = filteredByYearAndCategory[0].data - filteredByYearAndCategory.find(datum => datum.source !== 'tax_transcript').data
          if (diff > 0 || diff < 0) {
            discrepancies.push({ diff, discrepancy: true, year, category })
          }
        }
      }
    }
  }
  return discrepancies
}
